<template>
  <t-dialog
    v-model:visible="dialogVisible"
    header="选择不满原因"
    :footer="false"
    width="480px"
    @close="handleClose"
  >
    <div class="low-rating-modal">
      <p class="modal-tip">请选择您不满意的原因(可多选), 帮助我们做的更好：</p>
      <div class="reason-options">
        <div
          v-for="reason in reasons"
          :key="reason.value"
          class="reason-item"
          :class="{ selected: selectedReasons.includes(reason.value) }"
          @click="toggleReason(reason.value)"
        >
          <span class="reason-checkbox">
            <t-icon v-if="selectedReasons.includes(reason.value)" name="check" />
          </span>
          <span class="reason-text">{{reason.label}}</span>
        </div>
      </div>
      <div class="modal-actions">
        <t-button theme="primary" :loading="submitting" @click="handleSubmit">提交</t-button>
        <t-button theme="default" @click="handleClose">取消</t-button>
      </div>
    </div>
  </t-dialog>
</template>

<script>
import { ref, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { MessagePlugin } from 'tdesign-vue-next'

export default {
  name: 'LowRatingModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    score: {
      type: Number,
      required: true
    },
    courseId: {
      type: [Number, String],
      required: true
    }
  },
  emits: ['update:visible', 'success'],
  setup(props, { emit }) {
    const store = useStore()

    const dialogVisible = computed({
      get: () => props.visible,
      set: (val) => emit('update:visible', val)
    })

    const selectedReasons = ref([])
    const submitting = ref(false)

    const reasons = [
      { value: '内容难懂', label: '内容难懂' },
      { value: '找不到重点', label: '找不到重点' },
      { value: '内容陈旧', label: '内容陈旧' },
      { value: '没有实操案例', label: '没有实操案例' },
      { value: '内容太长', label: '内容太长' },
      { value: '图片/声音/画面不清晰', label: '图片/声音/画面不清晰' }
    ]

    const toggleReason = (reason) => {
      const index = selectedReasons.value.indexOf(reason)
      if (index > -1) {
        selectedReasons.value.splice(index, 1)
      } else {
        selectedReasons.value.push(reason)
      }
    }

    const handleClose = () => {
      selectedReasons.value = []
      dialogVisible.value = false
    }

    const handleSubmit = async () => {
      if (selectedReasons.value.length === 0) {
        // 可以用 Message 组件提示，但这里暂时用 alert
        MessagePlugin.warning('请选择不满的原因')
        return
      }
      submitting.value = true
      try {
        await store.dispatch('rating/submitRating', {
          courseId: props.courseId,
          score: props.score,
          dissatisfiedReasons: selectedReasons.value.join(';')
        })
        emit('success', {
          score: props.score,
          dissatisfiedReasons: selectedReasons.value
        })
        handleClose()
      } catch (error) {
        console.error('评分提交失败', error)
      } finally {
        submitting.value = false
      }
    }

    watch(() => props.visible, (newVal) => {
      if (newVal) {
        selectedReasons.value = []
      }
    })

    return {
      dialogVisible,
      reasons,
      selectedReasons,
      submitting,
      toggleReason,
      handleClose,
      handleSubmit
    }
  }
}
</script>

<style lang="scss" scoped>
.low-rating-modal {
  .modal-tip {
    font-size: 14px;
    color: #666;
    margin-bottom: 16px;
  }

  .reason-options {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 24px;

    .reason-item {
      display: flex;
      align-items: center;
      padding: 12px 16px;
      border: 1px solid #E7E7E7;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        border-color: #FD3374;
        background: #FFF0F5;
      }

      &.selected {
        border-color: #FD3374;
        background: #FFF0F5;

        .reason-checkbox {
          background: #FD3374;
          border-color: #FD3374;
          color: #fff;
        }
      }

      .reason-checkbox {
        width: 18px;
        height: 18px;
        border: 1px solid #D3D6DA;
        border-radius: 4px;
        margin-right: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
      }

      .reason-text {
        font-size: 14px;
        color: #333;
      }
    }
  }

  .modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }
}
</style>
